import * as ScreenCapture from 'expo-screen-capture';
import { useCallback } from 'react';
import { useFocusEffect } from 'expo-router';

import { isWeb } from '../config/designSystem/Layout';

/**
 * Blocks screenshots and screen recording while the screen is FOCUSED, and
 * releases the block as soon as it loses focus.
 *
 * `ScreenCapture.usePreventScreenCapture` only releases on unmount: a tab
 * screen (Settings) stays mounted once visited, so every screenshot of the
 * whole app came out black afterwards — on iOS since expo-screen-capture 8
 * (SDK 54), which turned the former recording-only block into a real
 * screenshot block.
 */
export const usePreventScreenCaptureWhileFocused = (key = 'default'): void => {
  useFocusEffect(
    useCallback(() => {
      if (isWeb) {
        return undefined;
      }
      ScreenCapture.preventScreenCaptureAsync(key).catch(() => undefined);
      return () => {
        ScreenCapture.allowScreenCaptureAsync(key).catch(() => undefined);
      };
    }, [key]),
  );
};
